import React from "react";
import { MessageCircle } from "lucide-react";
import { company } from "../mock";

const WhatsAppButton = () => {
  return (
    <a
      href={company.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile Teklif Al"
      className="wa-float fixed bottom-6 right-6 z-50 flex items-center gap-2.5 bg-[#22c55e] hover:bg-[#16a34a] text-white pl-4 pr-5 py-3.5 rounded-full font-semibold text-sm shadow-lg transition-colors duration-300"
    >
      <MessageCircle size={22} />
      <span className="hidden sm:inline">Teklif Al</span>
    </a>
  );
};

export default WhatsAppButton;
